const filterKey = [
  { title: "show all", key: "*" },
  { title: "Casino", key: "casino" },
  { title: "Dex", key: "Dex" },
  { title: "nft", key: "nft" },
  { title: "game", key: "game" },
  { title: "ecommerce", key: "ecommerce" },
  { title: "design", key: "design" },
  { title: "Trading Bot", key: "Trading Bot" },
];

const projectData = [
  {
    type: ["nft", "design"],
    role: "Frontend and Web3 Developer",
    skills: ["Next.js", "Web3.Js", "Solidity"],
    imgUrl: "imgs/works/nft10.jpg",
    summary:
      "Dual Staking Functionality, FlareDrop (WFLR) Delegation Pool, Purchase & Burn NINJA Token Buyback and Burn",
    siteUrl: "https://ninja.shogun-safari.xyz/",
  },
  {
    type: ["Dex", "design"],
    role: "Fullstack and Blockchain Developer",
    skills: ["Next.js", "Web3.Js", "Solana", "Smartcontract", "DB"],
    imgUrl: "imgs/works/solled.png",
    summary:
      "SOLLED is a next-gen Solana wallet built for culture, speed, and utility.re creating a wallet that goes beyond storage — it includes send, receive, swap, a built-in trading bot",
    siteUrl: "https://solled.com",
  },
  {
    type: ["game"],
    role: "FullStack Developer",
    skills: ["React.Js", "Node.Js", "Nextjs"],
    imgUrl: "imgs/works/game16.png",
    summary:
      "Galactic Kingdom is a space-themed strategy mobile game that aims to onboard Web 2 mobile gamers by blending addicting gameplay with the rewards unlocked by true digital asset ownership..",
    siteUrl: "https://www.galactickingdom.io/",
  },
  {
    type: ["game"],
    role: "FullStack Developer",
    skills: ["React.Js", "Node.Js", "smartcontract", "web3", "Nextjs", "tailwind", "Mongodb"],
    imgUrl: "imgs/works/game5.png",
    summary:
      "A fully customizable, on-chain Solana casino platform and rapid frontend deployment using Next.js and Web3 technologies.",
    siteUrl: "https://lastsend.pro/",
  },
  {
    type: ["game", "design"],
    role: "FullStack | Blockchain Developer",
    skills: ["React.Js", "Node.Js", "smartcontract", "web3", "Nextjs", "tailwind", "Mongodb"],
    imgUrl: "imgs/works/game7.png",
    summary:
      "A fully customizable, on-chain Solana casino betting platform featuring provably fair games, fee-sharing, and rapid frontend deployment using Next.js and Web3 technologies..",
    siteUrl: "https://Double.lol/",
  },
  {
    type: ["game", "design"],
    role: "FullStack | Blockchain Developer",
    skills: ["React.Js", "Node.Js", "smartcontract", "web3", "Nextjs", "tailwind", "Mongodb"],
    imgUrl: "imgs/works/game6.png",
    summary:
      "A fully customizable, on-chain etherium casino platform",
    siteUrl: "https://marvel.com/",
  },
  {
    type: ["game", "design"],
    role: "FullStack | Blockchain Developer",
    skills: ["React.Js", "Node.Js", "smartcontract", "web3", "Nextjs", "tailwind", "Mongodb"],
    imgUrl: "imgs/works/game8.png",
    summary:
      "A fully customizable, on-chain  web3 game platform",
    siteUrl: "https://gunz-game.vercel.app/",
  },
  {
    type: ["casino", "game"],
    role: "FullStack Developer",
    skills: ["React.Js", "Node.Js", "Ngnix"],
    imgUrl: "imgs/works/casino1.jpg",
    summary:
      "Platform for games like Baccarat, Roulette, Andar Bahar, Sic Bo, Dragon tiger, Designed and Built all.",
    siteUrl: "https://kasagames.com/",
  },
  {
    type: ["nft", "design"],
    role: "Frontend and Solidity Developer",
    skills: ["Next.Js", "Web3.Js"],
    imgUrl: "imgs/works/nft9.jpg",
    summary:
      "NFT Mint Project : 15% of the mint cost is shared with NFT holders.",
    siteUrl: "https://flaregods.xyz/",
  },
  {
    type: ["nft", "design"],
    role: "Fullstack  Developer",
    skills: ["Next.Js", "Web3.Js"],
    imgUrl: "imgs/works/work31.png",
    summary:
      "nft marketplace",
    siteUrl: "https://ghosty...",
  },
  {
    type: ["casino", "game"],
    role: "FullStack Developer",
    skills: ["React.Js", "Node.Js", "Ngnix"],
    imgUrl: "imgs/works/casino2.jpg",
    summary: "Sports Betting Site",
    siteUrl: "https://blockchainbets.club/",
  },

  {
    type: "game",
    role: "Game Developer",
    skills: ["Unity", "React.Js", "Node.Js", "Solana", "Rust"],
    imgUrl: "imgs/works/game11.jpg",
    summary: "DegenTaxi - Car Crash Game (Solana)",
    siteUrl: "https://degentaxi.io/",
  },
  {
    type: "game",
    role: "Frontend and Web3 Developer",
    skills: ["React.Js", "Node.Js", "AWS", "Solana", "Rust"],
    imgUrl: "imgs/works/game1.jpg",
    summary:
      "This is coin-flip game on solana network. Payment is Sol and users can put their amount in this game. ",
    siteUrl: "https://coinflip.deezkits.com/",
  },
  {
    type: ["nft"],
    role: "Frontend and Web3 Developer",
    skills: ["Next.Js", "Node.Js", "Three.Js", "Web3.Js"],
    imgUrl: "imgs/works/nft15.jpg",
    summary: "Cobalt NFT Minting",
    siteUrl: "https://cobalt.shop/",
  },
  {
    type: "game",
    role: "Solidity and Rust Developer",
    skills: ["React.Js", "Web3.Js", "Solidity", "Ethereum"],
    imgUrl: "imgs/works/game2.jpg",
    summary: "Crypto Legions Game (P2E)",
    siteUrl: "https://cryptolegions.app/",
  },
  {
    type: ["nft", "design"],
    role: "Frontend and Solidity Developer",
    skills: ["Next.Js", "Web3.Js", "Solidity"],
    imgUrl: "imgs/works/nft8.jpg",
    summary: "BeastiyBit NFT Minting",
    siteUrl: "https://beastybits.com/",
  },
  {
    type: ["nft", "design"],
    role: "Frontend and Solidity Developer",
    skills: ["Next.Js", "Web3.Js", "Solidity"],
    imgUrl: "imgs/works/nft7.jpg",
    summary: "CuteInsane NFT Minting | Staking",
    siteUrl: "https://cutetoinsane.online/",
  },
  {
    type: ["nft", "game"],
    role: "Solana Developer",
    skills: ["Next.Js", "Node.Js", "AWS", "Solana"],
    imgUrl: "imgs/works/game3.png",
    summary: "Solarmy | NFT Game | NFT Staking | Fusion",
    siteUrl: "https://game.solarmy.io/",
  },
  {
    type: ["nft", "design"],
    role: "Frontend and Solidity Developer",
    skills: ["React.Js", "Web3.Js", "Solidity"],
    imgUrl: "imgs/works/nft5.png",
    summary: "NFT Marketplace (Songbird Network)",
    siteUrl: "https://market.doodcats.net/",
  },
  {
    type: ["nft", "design"],
    role: "Frontend and Web3 Developer",
    skills: ["Next.Js", "Web3.Js", "Solidity"],
    imgUrl: "imgs/works/work2.jpg",
    summary: "NFT Minting | Staking",
    siteUrl: "https://doodlebunnyflr.live/",
  },
  {
    type: ["nft", "design"],
    role: "Frontend and Solidity Developer",
    skills: ["React.Js", "Web3.Js", "Solidity"],
    imgUrl: "imgs/works/nft3.jpg",
    summary: "NFT Staking in Songbird Network",
    siteUrl: "https://tsphunt.xyz/",
  },
  {
    type: ["nft", "design"],
    role: "Frontend and Solidity Developer",
    skills: ["React.Js", "Web3.Js", "Solidity"],
    imgUrl: "imgs/works/nft2.jpg",
    summary:
      "NFT Staking (Songbird Network). Holders may stake DoodCats v3 NFTs and DedDoods NFTs to earn sDOOD Token.",
    siteUrl: "https://doodcats.net/",
  },
  {
    type: ["nft", "design"],
    role: "Frontend and Solidity Developer",
    skills: ["React.Js", "Web3.Js", "Solidity"],
    imgUrl: "imgs/works/nft1.png",
    summary: "NFT Breeding Dapp",
    siteUrl: "https://portal.animalove.art/",
  },
  {
    type: ["nft"],
    role: "Frontend and Solidity Developer",
    skills: ["React.Js", "Web3.Js", "Solidity"],
    imgUrl: "imgs/works/nft6.jpg",
    summary:
      "CashCow Protocol (Designed the site with Figma, Built the staking and marketplace contract)",
    siteUrl: "https://cashcowprotocol.com/",
  },
  {
    type: "ecommerce",
    role: "FullStack Developer",
    skills: ["React.Js", "Node.Js", "GraphQL", "AWS"],
    imgUrl: "imgs/works/ecommerce2.jpg",
    summary: "Di Bruno Bros E-Commerce",
    siteUrl: "https://dibruno.com/",
  },
  {
    type: "ecommerce",
    role: "FullStack Developer",
    skills: ["React.Js", "Node.Js", "GraphQL"],
    imgUrl: "imgs/works/ecommerce5.jpg",
    summary: "MercariLogo Marketplace (Designed the site and the database.)",
    siteUrl: "https://www.mercari.com/",
  },
  {
    type: ["ecommerce", "design"],
    role: "FullStack Developer",
    skills: ["React.Js", "Node.Js"],
    imgUrl: "imgs/works/ecommerce1.jpg",
    summary: "Littlespoon E-Commerce",
    siteUrl: "https://www.littlespoon.com/",
  },
  {
    type: ["ecommerce", "design", "web3"],
    role: "FullStack |web3 Developer",
    skills: ["React.Js", "Node.Js", "DB", "web3"],
    imgUrl: "imgs/works/ecommerce3.png",
    summary: "E-Commerce",
    siteUrl: "https://justanegg.com/",
  },
  {
    type: ["ecommerce", "design", "web3"],
    role: "FullStack |web3 Developer",
    skills: ["React.Js", "Node.Js", "DB", "web3"],
    imgUrl: "imgs/works/ecommerce4.png",
    summary: "E-Commerce",
    siteUrl: "https://pusheen.com/",
  },
  {
    type: ["nft", "design"],
    role: "Fullstack and Solana Developer",
    skills: ["React.Js", "Web3.Js", "solana"],
    imgUrl: "imgs/works/nft12.png",
    summary: "NFT Staking in solana Network",
    siteUrl: "https://snargons.xyz/",
  },
  {
    type: ["web2", "design"],
    role: "Fullstack and Solana Developer",
    skills: ["React.Js", "DB", "nodejs", "express"],
    imgUrl: "imgs/works/24.png",
    summary: "Web2 fullstack hackerforce course project",
    siteUrl: "https://hackerforce.vercel.app",
  },
  {
    type: ["Dex", "design"],
    role: "Fullstack and Blockchain Developer",
    skills: ["Next.js", "Web3.Js", "Solana", "Smartcontract", "DB"],
    imgUrl: "imgs/works/dex2.png",
    summary:
      "Token Presale",
    siteUrl: "https://binky.doodlebunnyflr.live/",
  },
  {
    type: ["Dex", "design"],
    role: "Fullstack and Blockchain Developer",
    skills: ["Next.js", "Web3.Js", "Solana", "Smartcontract", "DB"],
    imgUrl: "imgs/works/dex1.png",
    summary:
      "Token Presale",
    siteUrl: "https://zoink.fomofactory.xyz/",
  },
  {
    type: ["Dex", "design"],
    role: "Fullstack and Blockchain Developer",
    skills: ["Next.js", "Web3.Js", "Solana", "Smartcontract", "DB"],
    imgUrl: "imgs/works/dex4.png",
    summary:
      "Pumpfun forking",
    siteUrl: "https://agents.land/",
  },
  {
    type: ["Trading Bot", "design"],
    role: "Fullstack and Blockchain Developer",
    skills: ["Next.js", "Web3.Js", "Solana", "Smartcontract", "DB"],
    imgUrl: "imgs/works/23.png",
    summary: "Solana Radyium Sniper Bot"
  },
  {
    type: ["DEX", "design"],
    role: "Fullstack and Blockchain Developer",
    skills: ["Next.js", "Web3.Js", "Solana", "Smartcontract", "DB"],
    imgUrl: "imgs/works/22.png",
    summary: "Pump.fun smart contract"
  },
  {
    type: ["Trading Bot", "design"],
    role: "Fullstack and Blockchain Developer",
    skills: ["Next.js", "Web3.Js", "Solana", "Smartcontract", "DB"],
    imgUrl: "imgs/works/21.png",
    summary: "PumpFun Bundler"
  },
  {
    type: ["Trading Bot", "design"],
    role: "Fullstack and Blockchain Developer",
    skills: ["Next.js", "Web3.Js", "Solana", "Smartcontract", "DB"],
    imgUrl: "imgs/works/20.png",
    summary: "Telegram ElementalBlast Game",
    siteUrl: "https://t.me/ElementalBlastBot/IceNinja",
  },
  {
    type: ["Trading Bot", "design"],
    role: "Fullstack and Blockchain Developer",
    skills: ["Next.js", "Web3.Js", "Solana", "Smartcontract", "DB"],
    imgUrl: "imgs/works/bot3.png",
    summary: "Telegram pumpfun sniper bot",
  },
  {
    type: ["Trading Bot", "design"],
    role: "Fullstack and Blockchain Developer",
    skills: ["Next.js", "Web3.Js", "Solana", "Smartcontract", "DB"],
    imgUrl: "imgs/works/bot4.png",
    summary: "#Pump AMM  #Raydium V4 #Raydium CPMM #Raydium CLMM #Meteora DLMM #Meteora Dynamic AMM #Meteora DAMM V2 #Ocra #Solfi #Vertigo ",
  },
];

export { filterKey, projectData };
